import { render, staticRenderFns } from "./LayoutTwoColumns.vue?vue&type=template&id=cde090ca&scoped=true&"
import script from "./LayoutTwoColumns.vue?vue&type=script&lang=ts&"
export * from "./LayoutTwoColumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde090ca",
  null
  
)

export default component.exports